<div class="backgroundlogin">
	<div class="row">
		<div>
			<div class="loginds">
				<div class="bran-actview"><a class="logo-login">{{'act.actview' | translate}}</a>
				</div>
				<div>
					<form class="form col-md-12 center-block" (ngSubmit)="f.form.valid && onLogin(f)" #f="ngForm" ngNativeValidate>
						<div
							class="form-group usrn"
							[ngClass]="{ 'has-error': f.submitted && !username.valid }">
							<input
							 type="email"
							 class="form-control input-lg"
							 name="username"
							 required
							 ngModel
							 #username="ngModel"
							 placeholder="{{'user.user_name' | translate}}" >
						</div>
						<div
							class="form-group pasn"
							[ngClass]="{ 'has-error': f.submitted && !password.valid }">
							<input
							  type="password"
							  placeholder="{{'user.' | translate}}Password"
							  class="form-control input-lg"
							  required
							  name="password"
							  ngModel
							  #password="ngModel">
						</div>
						<div class="form-group row">
							<div class="col-xs-6">
 							<button
								 type="button"
								 (click)="isSsoLoginInProgress ? clearSsoLoginStatus() : onMsalLogin()"
								 class="btn btn-light-primary btnlogn btn-block sso-login-btn"
								 [title]="isSsoLoginInProgress ? ('user.sso_login_in_progress' | translate) : ''">
								 	<b class="sso-main-text">{{ 'user.sso_login' | translate }}</b>
								 	<span class="sso-progress-text" *ngIf="isSsoLoginInProgress">
								 		<br><small>in progress... (click to cancel)</small>
								 	</span>
								 </button>
							</div>
							<div class="col-xs-6">
								<button
								 type="submit" [disabled]="(showCaptcha && !loginBlock.recaptcha) || disableStandardLogin"
								 class="btn btn-primary btnlogn btn-block">
								 	<b>{{'user.sign_in' | translate}}</b>
								 </button>
							</div>
						</div>
						<div class="tcenter">
							<a
							 routerLink="/forgot-password"
							 class="pointer">
							 	<span class="glyphicon glyphicon-lock"></span>
								 {{'user.forgot_password' | translate}}</a>
						</div>
						<div *ngIf="showCaptcha">
							<p-captcha #captcha siteKey="6LeVcCAUAAAAAEKZnR7tM3nEinNQE0JEzAbmQqXj" (onResponse)="loginBlock.recaptcha = $event.response" (onExpire)="loginBlock.recaptcha = ''"></p-captcha>
						</div>

						<!-- Popup troubleshooting help -->
						<div class="popup-help" *ngIf="showPopupHelp" style="margin-top: 15px; padding: 10px; background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 4px; font-size: 12px;">
							<div style="font-weight: bold; margin-bottom: 8px; color: #495057;">
								<i class="fa fa-info-circle" style="margin-right: 5px;"></i>
								SSO Login Troubleshooting
							</div>
							<div style="color: #6c757d; line-height: 1.4;">
								If SSO login isn't working:
								<ul style="margin: 5px 0; padding-left: 20px;">
									<li>Allow popups for this site in your browser</li>
									<li>Disable popup blockers temporarily</li>
									<li>Try using redirect-based authentication</li>
									<li>Clear your browser cache and cookies</li>
								</ul>
								<button
									type="button"
									class="btn btn-sm btn-outline-primary"
									style="margin-top: 5px; font-size: 11px;"
									(click)="tryRedirectAuth()">
									Try Redirect Authentication
								</button>
								<button
									type="button"
									class="btn btn-sm btn-outline-secondary"
									style="margin-top: 5px; margin-left: 5px; font-size: 11px;"
									(click)="showPopupHelp = false">
									Hide Help
								</button>
							</div>
						</div>

						<!-- Show popup help link -->
						<div class="tcenter" *ngIf="!showPopupHelp" style="margin-top: 10px;">
							<a href="javascript:void(0)"
							   (click)="showPopupHelp = true"
							   style="font-size: 12px; color: #6c757d; text-decoration: none;">
								<i class="fa fa-question-circle" style="margin-right: 3px;"></i>
								SSO Login Issues?
							</a>
						</div>
					</form>
				</div>
				<div class="col-md-12 center-block">
					<button
					 class="btn btn-default btnlogn btn-block"
					 routerLink="/register"><b>{{'user.register' | translate}}</b>
					</button>
				</div>
			</div>
		</div>
	</div>
	<div class="copyrit">{{'g.copyright' | translate}} © {{yearAge}} {{(isAct ? 'act.actview' : 'act.powered_by_act') | translate}}</div>
</div>
